import { invalidateCallableReadAdmission } from '@kop/operations-firebase-adapter';

const CLEAR_EVENT = 'kop:sensitive-memory-cache-clear';
const clearHandlers = new Set<() => void>();

export function clearSensitiveMemoryCaches() {
  invalidateCallableReadAdmission();
  for (const clear of clearHandlers) clear();
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(CLEAR_EVENT));
}

export function onSensitiveMemoryCacheClear(clear: () => void) {
  clearHandlers.add(clear);
  return () => clearHandlers.delete(clear);
}

export function millisecondsUntilNextMidnight(now = new Date()) {
  const next = new Date(now);
  next.setHours(24, 0, 0, 0);
  return Math.max(1, next.getTime() - now.getTime());
}

export function scheduleMidnightMemoryCacheClear() {
  if (typeof window === 'undefined') return () => undefined;
  let timer = 0;
  const schedule = () => {
    timer = window.setTimeout(() => {
      clearSensitiveMemoryCaches();
      schedule();
    }, millisecondsUntilNextMidnight());
  };
  schedule();
  return () => window.clearTimeout(timer);
}
